import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import {
  httpGet,
  httpPut,
  httpPost,
  httpDelete,
} from "../../services/httpService";
import {
  getMembersUrl,
  getServicesUrl,
  addMemberUrl,
  updateMemberUrl,
  updateMemberUrlV2,
  getMemberByIdUrl,
  getOrbitAgencyServicesByCompanyId,
  deleteUserByIdUrl,
  addCertificateUrl,
  addUpdatePinCodeUrl,
  addDigitalSignatureUrl,
  deleteDigitalSignatureUrl,
  updateUserProfileUrl,
  updateUserWeekAvailabilityUrl,
  getUsersProfileUrl,
  addUserAccreditationUrl,
  deleteUserAccreditationUrl,
  viewUserAccreditationUrl,
  deleteDigitalCertificateUrl,
  getPendingInvitesUrl,
  deleteInviteUrl,
  getDefaultCompanyServiceUrl,
  getMembersUrlV2,
  getMembersWithActiveAvailabilityUrl,
} from "../../apiUrls/apiUrls";
import { logErrorWithPayload } from "../../services/logService";

const initialState = {
  isMemberLoading: false,
  membersData: null,
  rolesData: null,
  servicesData: null,
  currentMember: null,
  lastMemberAddedUpdated: null,
  memberById: [],
  pharmanautServiceLoader: false,
  pharmanautServices: [],
  isCertificateAdded: false,
  isCertificateLoading: false,
  isPinCodeLoading: false,
  isPinCodeAdded: false,
  digitalSignature: false,
  isAddDigitalSignatureLoading: false,
  isDeleteDigitalSignatureLoading: false,
  isCurrentMemberLoading: false,
  isCurrentProfileLoading: false,
  isUserWeekAvailabilityLoading: false,
  userProfiles: null,
  userAccreditations: null,
  deleteAccreditation: false,
  accreditationData: null,
  isdeleteDigitalCertificateLoading: false,
  pendingInvites: [],
  isPendingInvitesLoading: false,
  isResendInviteLoading: false,
  isDeleteInviteLoading: false,
  isPharmacyServiceLoading: false,
  defaultPharmacyServices: [],
};

export const getMemberData = createAsyncThunk(
  "member/getMemberData",
  async (companyId, thunkAPI) => {
    const urlToGet = getMembersUrl(companyId);
    const respData = await httpGet(urlToGet);
    return respData;
  },
);

export const getMemberDataV2 = createAsyncThunk(
  "member/getMemberDataV2",
  async (companyId, thunkAPI) => {
    const urlToGet = getMembersUrlV2(companyId);
    const respData = await httpGet(urlToGet);
    return respData;
  },
);

export const getMembersWithActiveAvailabilityData = createAsyncThunk(
  "member/getMembersWithActiveAvailabilityData",
  async (companyId, thunkAPI) => {
    const urlToGet = getMembersWithActiveAvailabilityUrl(companyId);
    const respData = await httpGet(urlToGet);
    return respData;
  },
);

export const getServicesData = createAsyncThunk(
  "member/getServicesData",
  async () => {
    const urlToGet = getServicesUrl();
    const respData = await httpGet(urlToGet);
    return respData?.services;
  },
);

export const getMemberByIdData = createAsyncThunk(
  "member/getMemberByIdData",
  async (memberId, thunkAPI) => {
    const respData = await httpGet(getMemberByIdUrl(memberId));
    return respData;
  },
);

export const addMemberData = createAsyncThunk(
  "member/addMemberData",
  async (data, thunkAPI) => {
    const respData = await httpPost(addMemberUrl(), data);
    return respData;
  },
);

export const updateMemberData = createAsyncThunk(
  "member/updateMemberData",
  async (data, thunkAPI) => {
    const respData = await httpPut(updateMemberUrl(), data);
    return respData;
  },
);

export const updateMemberDataV2 = createAsyncThunk(
  "member/updateMemberDataV2",
  async (data, thunkAPI) => {
    const respData = await httpPut(updateMemberUrlV2(), data);
    return respData;
  },
);

export const getOrbitAgencyServicesByCompanyIdData = createAsyncThunk(
  "orbit/getOrbitAgencyServicesByCompanyIdData",
  async (companyID) => {
    const respData = await httpGet(
      getOrbitAgencyServicesByCompanyId(companyID),
    );
    return respData;
  },
);

export const deleteUserByIdData = createAsyncThunk(
  "user/deleteUser",
  async (email) => {
    const respData = await httpDelete(deleteUserByIdUrl(email));
    return respData;
  },
);

export const generateCertificateData = createAsyncThunk(
  "member/generateCertificateData",
  async (data) => {
    const url = addCertificateUrl();
    const respData = await httpPost(url);
    return respData;
  },
);

export const addPinCodeData = createAsyncThunk(
  "member/addPinCodeData",
  async (data) => {
    const url = addUpdatePinCodeUrl();
    const respData = await httpPost(url, data);
    return respData;
  },
);

export const addDigitalSignatureData = createAsyncThunk(
  "member/addDigitalSignatureData",
  async (data) => {
    const url = addDigitalSignatureUrl();
    const respData = await httpPost(url, data);
    return respData;
  },
);

export const deleteDigitalSignatureData = createAsyncThunk(
  "member/deleteDigitalSignatureData",
  async (userEmail) => {
    const url = deleteDigitalSignatureUrl(userEmail);
    const respData = await httpDelete(url);
    return respData;
  },
);
export const updateCurrentMemberProfileData = createAsyncThunk(
  "member/updateCurrentMemberProfileData",
  async (data) => {
    const url = updateUserProfileUrl();
    const respData = await httpPut(url, data);
    return respData;
  },
);
export const updateUserWeekAvailabilityData = createAsyncThunk(
  "member/updateUserWeekAvailabilityData",
  async (data) => {
    const url = updateUserWeekAvailabilityUrl();
    const respData = await httpPut(url, data);
    return respData;
  },
);

export const getUsersProfileData = createAsyncThunk(
  "member/getUsersProfileData",
  async (memberId, thunkAPI) => {
    const respData = await httpGet(getUsersProfileUrl());
    return respData;
  },
);

export const addUserAccreditationData = createAsyncThunk(
  "member/addUserAccreditationData",
  async (data) => {
    const url = addUserAccreditationUrl();
    const respData = await httpPost(url, data);
    return respData;
  },
);
export const deleteUserAccreditationData = createAsyncThunk(
  "member/deleteUserAccreditationData",
  async (accreditationID) => {
    const url = deleteUserAccreditationUrl(accreditationID);
    const respData = await httpDelete(url);
    return respData;
  },
);
export const viewUserAccreditationData = createAsyncThunk(
  "member/viewUserAccreditationData",
  async (accreditationID, thunkAPI) => {
    const respData = await httpGet(viewUserAccreditationUrl(accreditationID));
    return respData;
  },
);

export const deleteDigitalCertificateData = createAsyncThunk(
  "member/deleteDigitalCertificateData",
  async (userEmail) => {
    const url = deleteDigitalCertificateUrl(userEmail);
    const respData = await httpDelete(url);
    return respData;
  },
);

export const getPendingInvitesData = createAsyncThunk(
  "member/getPendingInvitesData",
  async (companyId, thunkAPI) => {
    const respData = await httpGet(getPendingInvitesUrl(companyId)); // you'll bind the URL
    return respData;
  },
);

export const deleteInviteData = createAsyncThunk(
  "member/deleteInviteData",
  async (inviteId, thunkAPI) => {
    const respData = await httpDelete(deleteInviteUrl(inviteId)); // now resolves correctly
    return respData;
  },
);

export const getDefaultCompanyServiceUrlData = createAsyncThunk(
  "member/getDefaultCompanyServiceUrlData",
  async (companyId, thunkApi) => {
    const urlToGet = getDefaultCompanyServiceUrl(companyId);
    const respData = await httpGet(urlToGet);
    return respData;
  },
);

export const memberSlice = createSlice({
  name: "member",
  initialState,
  reducers: {
    setIsMemberLoading: (state, action) => {
      state.isMemberLoading = action?.payload || false;
    },
    setMembersData: (state, action) => {
      state.membersData = action?.payload;
    },
    setRolesData: (state, action) => {
      state.rolesData = action?.payload;
    },
    setServicesData: (state, action) => {
      state.servicesData = action?.payload;
    },
    setCurrentMemberData: (state, action) => {
      state.currentMember = action?.payload || null;
    },

    resetMemberState: () => initialState,
  },
  extraReducers: (builder) => {
    builder
      .addCase(getMemberData.pending, (state) => {
        state.isMemberLoading = true;
      })
      .addCase(getMemberData.fulfilled, (state, action) => {
        state.isMemberLoading = false;
        state.membersData = action?.payload;
      })
      .addCase(getMemberData.rejected, (state, action) => {
        state.isMemberLoading = false;
        state.membersData = [];
      })
      .addCase(getMemberDataV2.pending, (state) => {
        state.isMemberLoading = true;
      })
      .addCase(getMemberDataV2.fulfilled, (state, action) => {
        state.isMemberLoading = false;
        state.membersData = action?.payload;
      })
      .addCase(getMemberDataV2.rejected, (state, action) => {
        state.isMemberLoading = false;
        state.membersData = [];
      })
      .addCase(getMembersWithActiveAvailabilityData.pending, (state) => {
        state.isMemberLoading = true;
      })
      .addCase(getMembersWithActiveAvailabilityData.fulfilled, (state, action) => {
        state.isMemberLoading = false;
        state.membersData = action?.payload;
      })
      .addCase(getMembersWithActiveAvailabilityData.rejected, (state) => {
        state.isMemberLoading = false;
        state.membersData = [];
      })

      .addCase(getServicesData.pending, (state) => {
        state.isMemberLoading = true;
      })
      .addCase(getServicesData.fulfilled, (state, action) => {
        state.isMemberLoading = false;
        state.servicesData = action?.payload;
      })
      .addCase(getServicesData.rejected, (state, action) => {
        logErrorWithPayload(action?.error);
        state.isMemberLoading = false;
        state.servicesData = null;
      })

      .addCase(getMemberByIdData.pending, (state) => {
        state.isMemberLoading = true;
      })
      .addCase(getMemberByIdData.fulfilled, (state, action) => {
        state.isMemberLoading = false;
        state.currentMember = action?.payload;
      })
      .addCase(getMemberByIdData.rejected, (state, action) => {
        logErrorWithPayload(action?.error);
        state.isMemberLoading = false;
        state.currentMember = null;
      })

      .addCase(addMemberData.pending, (state) => {
        state.isMemberLoading = true;
      })
      .addCase(addMemberData.fulfilled, (state, action) => {
        state.isMemberLoading = false;
        state.lastMemberAddedUpdated = action?.payload;
      })
      .addCase(addMemberData.rejected, (state, action) => {
        logErrorWithPayload(action?.error);
        state.isMemberLoading = false;
        state.lastMemberAddedUpdated = null;
      })

      .addCase(updateMemberData.pending, (state) => {
        state.isMemberLoading = true;
      })
      .addCase(updateMemberData.fulfilled, (state, action) => {
        state.isMemberLoading = false;
        state.lastMemberAddedUpdated = action?.payload;
      })
      .addCase(updateMemberData.rejected, (state, action) => {
        logErrorWithPayload(action?.error);
        state.isMemberLoading = false;
        state.lastMemberAddedUpdated = null;
      })
      .addCase(updateMemberDataV2.pending, (state) => {
        state.isMemberLoading = true;
      })
      .addCase(updateMemberDataV2.fulfilled, (state, action) => {
        state.isMemberLoading = false;
        state.lastMemberAddedUpdated = action?.payload;
      })
      .addCase(updateMemberDataV2.rejected, (state, action) => {
        logErrorWithPayload(action?.error);
        state.isMemberLoading = false;
        state.lastMemberAddedUpdated = null;
      })
      .addCase(
        getOrbitAgencyServicesByCompanyIdData.pending,
        (state, action) => {
          state.pharmanautServiceLoader = true;
        },
      )
      .addCase(
        getOrbitAgencyServicesByCompanyIdData.fulfilled,
        (state, action) => {
          state.pharmanautServiceLoader = false;
          state.pharmanautServices = action?.payload;
        },
      )
      .addCase(
        getOrbitAgencyServicesByCompanyIdData.rejected,
        (state, action) => {
          state.pharmanautServiceLoader = false;
        },
      )
      .addCase(deleteUserByIdData.pending, (state) => {
        state.isMemberLoading = true;
      })
      .addCase(deleteUserByIdData.fulfilled, (state) => {
        state.isMemberLoading = false;
      })
      .addCase(deleteUserByIdData.rejected, (state, action) => {
        state.isMemberLoading = false;
      })
      .addCase(generateCertificateData.pending, (state) => {
        state.isCertificateLoading = true;
      })
      .addCase(generateCertificateData.fulfilled, (state, action) => {
        state.isCertificateAdded = action?.payload || false;
        state.userProfiles = action?.payload?.user || {};
        state.isCertificateLoading = false;
      })
      .addCase(generateCertificateData.rejected, (state, action) => {
        state.isCertificateLoading = false;
      })
      .addCase(addPinCodeData.pending, (state) => {
        state.isPinCodeLoading = true;
      })
      .addCase(addPinCodeData.fulfilled, (state, action) => {
        state.userProfiles = action?.payload || false;
        state.isPinCodeLoading = false;
      })
      .addCase(addPinCodeData.rejected, (state, action) => {
        state.isPinCodeLoading = true;
      })
      .addCase(addDigitalSignatureData.pending, (state) => {
        state.isAddDigitalSignatureLoading = true;
      })
      .addCase(addDigitalSignatureData.fulfilled, (state, action) => {
        state.digitalSignature = action?.payload || "";
        state.isAddDigitalSignatureLoading = false;
      })
      .addCase(addDigitalSignatureData.rejected, (state, action) => {
        state.isAddDigitalSignatureLoading = true;
      })
      .addCase(deleteDigitalSignatureData.pending, (state) => {
        state.isDeleteDigitalSignatureLoading = true;
      })
      .addCase(deleteDigitalSignatureData.fulfilled, (state, action) => {
        state.digitalSignature = "";
        state.isDeleteDigitalSignatureLoading = false;
      })
      .addCase(deleteDigitalSignatureData.rejected, (state, action) => {
        state.isDeleteDigitalSignatureLoading = true;
      })
      .addCase(updateCurrentMemberProfileData.pending, (state) => {
        state.isCurrentProfileLoading = true;
      })
      .addCase(updateCurrentMemberProfileData.fulfilled, (state, action) => {
        state.currentMember = action?.payload || "";
        state.isCurrentProfileLoading = false;
      })
      .addCase(updateCurrentMemberProfileData.rejected, (state, action) => {
        state.isCurrentProfileLoading = false;
      })
      .addCase(updateUserWeekAvailabilityData.pending, (state) => {
        state.isUserWeekAvailabilityLoading = true;
      })
      .addCase(updateUserWeekAvailabilityData.fulfilled, (state, action) => {
        state.currentMember = action?.payload || "";
        state.isUserWeekAvailabilityLoading = false;
      })
      .addCase(updateUserWeekAvailabilityData.rejected, (state, action) => {
        state.isUserWeekAvailabilityLoading = false;
      })
      .addCase(getUsersProfileData.pending, (state) => {
        state.isMemberLoading = true;
      })
      .addCase(getUsersProfileData.fulfilled, (state, action) => {
        state.isMemberLoading = false;
        state.userProfiles = action?.payload;
      })
      .addCase(getUsersProfileData.rejected, (state, action) => {
        logErrorWithPayload(action?.error);
        state.isMemberLoading = false;
        state.userProfiles = null;
      })
      .addCase(addUserAccreditationData.pending, (state) => {
        state.isCurrentProfileLoading = true;
      })
      .addCase(addUserAccreditationData.fulfilled, (state, action) => {
        state.userAccreditations = action?.payload || "";
        state.isCurrentProfileLoading = false;
      })
      .addCase(addUserAccreditationData.rejected, (state, action) => {
        state.isCurrentProfileLoading = false;
      })
      .addCase(deleteUserAccreditationData.pending, (state) => {
        state.isCurrentProfileLoading = true;
      })
      .addCase(deleteUserAccreditationData.fulfilled, (state, action) => {
        state.deleteAccreditation = "";
        state.isCurrentProfileLoading = false;
      })
      .addCase(deleteUserAccreditationData.rejected, (state, action) => {
        state.isCurrentProfileLoading = true;
      })
      .addCase(viewUserAccreditationData.pending, (state) => {
        state.isCurrentProfileLoading = true;
      })
      .addCase(viewUserAccreditationData.fulfilled, (state, action) => {
        state.isCurrentProfileLoading = false;
        state.accreditationData = action?.payload;
      })
      .addCase(viewUserAccreditationData.rejected, (state, action) => {
        logErrorWithPayload(action?.error);
        state.isCurrentProfileLoading = false;
        state.accreditationData = null;
      })
      .addCase(deleteDigitalCertificateData.pending, (state) => {
        state.isdeleteDigitalCertificateLoading = true;
      })
      .addCase(deleteDigitalCertificateData.fulfilled, (state, action) => {
        state.isdeleteDigitalCertificateLoading = false;
      })
      .addCase(deleteDigitalCertificateData.rejected, (state, action) => {
        state.isdeleteDigitalCertificateLoading = false;
      })
      .addCase(getPendingInvitesData.pending, (state) => {
        state.isPendingInvitesLoading = true;
      })
      .addCase(getPendingInvitesData.fulfilled, (state, action) => {
        state.isPendingInvitesLoading = false;
        state.pendingInvites = action?.payload || [];
      })
      .addCase(getPendingInvitesData.rejected, (state) => {
        state.isPendingInvitesLoading = false;
        state.pendingInvites = [];
      })
      .addCase(deleteInviteData.pending, (state) => {
        state.isDeleteInviteLoading = true;
      })
      .addCase(deleteInviteData.fulfilled, (state, action) => {
        state.isDeleteInviteLoading = false;
      })
      .addCase(deleteInviteData.rejected, (state) => {
        state.isDeleteInviteLoading = false;
      })
      .addCase(getDefaultCompanyServiceUrlData.pending, (state, action) => {
        state.isPharmacyServiceLoading = true;
      })
      .addCase(getDefaultCompanyServiceUrlData.fulfilled, (state, action) => {
        state.isPharmacyServiceLoading = false;
        state.defaultPharmacyServices = action?.payload;
      })
      .addCase(getDefaultCompanyServiceUrlData.rejected, (state, action) => {
        state.isPharmacyServiceLoading = false;
      });
  },
});

// Action creators are generated for each case reducer function
export const {
  setIsMemberLoading,
  setMembersData,
  setRolesData,
  setServicesData,
  setCurrentMemberData,
} = memberSlice.actions;

export default memberSlice.reducer;
